import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-preparations',
  templateUrl: './catalogs-preparations.component.html',
  styleUrls: ['./catalogs-preparations.component.scss']
})
export class CatalogsPreparationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
